












import { defineComponent } from 'vue';
import type Tab from '@/data/Tab';
import { ImageLikeSource } from '@/data/Source';

export default defineComponent({
  name: 'CanvasSourceTab',
  props: {
    source: {
      type: Object as () => Tab,
      required: true,
    },
  },
  setup(props) {
    const topMargin = ImageLikeSource.TOTAL_MARGIN;
    return { topMargin };
  },
});
